<template>
    <div class="body">
        <p class="p1" style="padding-top: 8vh;">Hi~ <a class="highlight">{{ ReportData.stuname }}</a>，我们又见面啦</p>
        <p class="p3">让我们一起，回望2025年走过的每一步。</p>

        <div v-show="ReportData.hyear && ReportData.hyear>0">
            <p class="p5">转眼一年已经过去,</p>
            <p class="p6">感谢您与富士康科技集团携手走过<a class="highlight">{{ ReportData.hyear }}</a>年🎉</p>
        </div>

        <p class="p7">那些努力与积累，</p>
        <p class="p6">正悄悄汇成属于你的成长轨迹。</p>

        <div style="display: flex;justify-content: center;align-items: center;">
            <img class="img" v-if="ReportData.hyear <= 1" src='@/assets/25Year/horse1.png' alt="house9" style="width: 50%;"/>
            <img class="img" v-else-if="ReportData.hyear > 1 && ReportData.hyear <= 3" src='@/assets/25Year/horse2.webp' alt="house8"/>
            <img class="img" v-else-if="ReportData.hyear > 3 && ReportData.hyear <= 5" src='@/assets/25Year/horse3.png' alt="house8"/>
            <img class="img" v-else-if="ReportData.hyear > 5 && ReportData.hyear <= 10" src='@/assets/25Year/horse4.png' alt="house8"/>
            <img class="img" v-else-if="ReportData.hyear > 10 && ReportData.hyear <= 15" src='@/assets/25Year/horse5.png' alt="house8"/>
            <img class="img" v-else src='@/assets/25Year/horse6.png' alt="house8"/>
        </div>
        <p class="p10" style="font-size: 15px;text-align: center;margin: 0;color: #fff;margin-top: 4vh;">左滑，开启专属于你的年度学习报告吧～</p>
    </div>
</template>
  
<script>
export default {
    props: [ "ReportData"]
}
</script>

<style scoped>
.body {
    background: url("../../assets/25October/logo.png") right  top  no-repeat,
                /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
                url("../../assets/25Year/bg.png")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.p1,.p2, .p3, .p4 {
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  .highlight {
    font-size: 26px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    width: 88%;
    margin: 0 auto;
    text-align: left;
    font-size: 16px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }

  .p5, .p7{
    margin-top: 20px;
  }
  .img{
    width: 40%;
  }
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25Year/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .p1,.p2, .p3, .p4 {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    font-size: 25px;
    color: #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .highlight {
    font-size: 35px;
    color: purple;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
 
  .p5, .p6, .p7, .p8{
    margin:0 auto;
    text-align: center;
    font-size: 20px;
    width: 92%;
  }

  .p5, .p7{
    margin-top: 20px;
  }
  .img{
    width: 20%;
  }
}
</style>